export default __webpack_public_path__ + "static/media/Spin-1s-200px.2a402b64.gif";